module.exports = __webpack_public_path__ + "img/Pierce.69859468.jpg";